import React from 'react';
import { Button } from './ui/button';

export const Navbar = () => {
  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0F172A]/80 backdrop-blur-lg border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="text-white font-bold text-xl tracking-tight">
            Los Propios Tech
          </div>

          {/* Nav Items */}
          <div className="flex items-center gap-6">
            <a 
              href="#agentes" 
              className="text-white/80 hover:text-white transition-colors duration-300 text-sm font-medium"
            >
              Agentes
            </a>
            <Button 
              variant="outline" 
              className="border-white/20 text-white hover:bg-white/10 hover:border-white/40 transition-all duration-300"
              onClick={() => window.open('https://wa.me/584225997721', '_blank')}
            >
              Contáctanos
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};
